import React, { Component } from "react";
import LinkPaymentMethodLayout from "home/components/link-payment-method-layout";
import { StripeProvider } from "react-stripe-elements";
import { apiFetch } from "apiFetch";
import { toast } from "react-toastify";

class LinkPaymentMethod extends Component {
  resetState = () => {
    this.setState({
      showSuccessMessage: false,
      showErrorMessage: false,
      checkedTerms: false
    });
  };

  handleSubmitNewBankAccount = (ev, bankPaymentMethod) => {
    ev.preventDefault();

    var bankAccountParams = {
      country: document.getElementById("country").value,
      currency: document.getElementById("currency").value,
      account_number: document.getElementById("account-number").value,
      account_holder_name: document.getElementById("account-holder-name").value,
      account_holder_type: document.getElementById("account-holder-type").value,
      bank_name: document.getElementById("bank-name").value
    };

    if (document.getElementById("routing-number").value !== "") {
      bankAccountParams["routing_number"] = document.getElementById(
        "routing-number"
      ).value;
    }

    let that = this;

    bankPaymentMethod.props.stripe
      .createToken("bank_account", bankAccountParams)
      .then(({ token, error }) => {
        const url = `/api/payment_methods/${this.props.currentPlan.paymentId}`;

        if (!token) {
          toast.error(error.message);
        } else {
          let bankAccount = token.bank_account;
          delete token.bank_account;

          apiFetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(token),
          })
          .then(function(response) {
            bankAccount.customerId = response.data.customerId;
            bankAccount.sourceId = bankAccount.id;

            that.props.handleShow("LinkPaymentMethod", false);
            that.props.addPaymentMethod(bankAccount);

            that.props.handleUpdateAch(bankAccount);
            that.props.handleShow("BankAccountAchMessage", true);

            toast.success(
              "Your bank account was successfully linked to your Finpay account."
            );
          })
          .catch(({error}) => {
            toast.error(error);
          });
        }
      });
  };

  handleSubmitNewCard = (ev, cardPaymentMethod) => {
    ev.preventDefault();

    let cardParams = {
      name: ev.target.holderName.value
    };

    cardPaymentMethod.props.stripe.createToken(cardParams).then(({ token }) => {
      if (!!token) {
        let url = `/api/payment_methods/${this.props.currentPlan.paymentId}`;
        apiFetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(token),
        })
        .then(() => {
          this.props.handleShow("LinkPaymentMethod", false);
          this.props.addPaymentMethod(token.card);
          toast.success(
            "Your card was successfully linked to your Finpay account."
          );
        })
        .catch(error => {
          toast.error(error.message);
        });

        cardPaymentMethod._element.clear();
      }
    });
  };

  render() {
    return (
      <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
        <LinkPaymentMethodLayout
          {...this.props}
          {...this.state}
          handleSubmitNewCard={this.handleSubmitNewCard}
          handleSubmitNewBankAccount={this.handleSubmitNewBankAccount}
          resetState={this.resetState}
        />
      </StripeProvider>
    );
  }
}

export default LinkPaymentMethod;



// WEBPACK FOOTER //
// ./src/home/containers/link-payment-method.js